import { CSSProperties } from "react";
import ReactCountryFlag from "react-country-flag";
interface Props {
  countryCode: string;
  width: number;
  style?: CSSProperties;
}
const Flag: React.FC<Props> = ({ countryCode, width, style = {} }) => {
  return (
    <ReactCountryFlag
      svg
      countryCode={countryCode?.toUpperCase()}
      style={{ ...style, width: width, height: width / 1.3 }}
      alt={countryCode?.toUpperCase()}
    />
  );
};

export default Flag;
